import { ChangeEvent } from 'react';
import { Upload } from 'lucide-react';

interface FileInputProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  multiple?: boolean;
}

const FileInput = ({ onChange, disabled, multiple }: FileInputProps) => (
  <div className="relative">
    <input
      type="file"
      onChange={onChange}
      disabled={disabled}
      multiple={multiple}
      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-not-allowed"
    />
    <div className="flex items-center gap-2 px-4 py-2 border rounded-lg hover:bg-gray-50">
      <Upload className="h-4 w-4 text-primary" />
      <span className="text-sm text-gray-600">{multiple ? 'Выберите файлы' : 'Выберите файл'}</span>
    </div>
  </div>
);

export default FileInput;
